import React from "react";
import { Box } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Underline tabs. `tabs = [{ value, label, count? }]`.
 */
const TabSwitcher = ({ value, onChange, tabs = [] }) => (
  <Box
    sx={{
      display: "flex",
      gap: 3,
      borderBottom: `1px solid ${TOKENS.border}`,
      mb: 2,
    }}
  >
    {tabs.map((t) => {
      const active = t.value === value;
      return (
        <Box
          key={t.value}
          onClick={() => onChange?.(t.value)}
          role="tab"
          tabIndex={0}
          aria-selected={active}
          sx={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            cursor: "pointer",
            userSelect: "none",
            pb: "10px",
            mt: "2px",
            fontSize: 13.5,
            fontWeight: active ? 600 : 500,
            color: active ? TOKENS.fg1 : TOKENS.fg2,
            borderBottom: `2px solid ${active ? TOKENS.primary : "transparent"}`,
            marginBottom: "-1px",
            transition: "color 120ms ease, border-color 120ms ease",
            "&:hover": { color: TOKENS.fg1 },
          }}
        >
          {t.label}
          {typeof t.count === "number" ? (
            <Box
              component="span"
              sx={{
                fontSize: 11,
                fontWeight: 600,
                color: active ? TOKENS.primaryInk : TOKENS.fg3,
                background: active ? TOKENS.primaryTint : TOKENS.bgSunken,
                borderRadius: 999,
                px: "8px",
                py: "2px",
                lineHeight: 1.2,
              }}
            >
              {t.count}
            </Box>
          ) : null}
        </Box>
      );
    })}
  </Box>
);

export default TabSwitcher;
